import { Component, Injector, OnInit } from '@angular/core';
import { inject } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com','s5-tech.com']

@Component({
  selector: 'app-fbscenarioedit',
  templateUrl: './fbscenarioedit.component.html',
  styleUrls: ['./fbscenarioedit.component.css']
})
export class FbscenarioeditComponent extends BaseComponent implements OnInit{
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  worldsRef: any;
  worlds: any; //downloaded worlds from database
  worldskeys: any = [] //keys of properties of worlds {id:0,name: "demo"}
  worldkey = 0 //index for select

  property: string
  scenario: any
  newScenarioName: string
  lessonplanStep: any
  showModalLessonplanStep = false

  constructor(injector: Injector) { super(injector) }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }
  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  async getData(){
    this.loader.show()
    this.property = this.getQueryParameter("property")
    const scenarioref = ref(this.database, 'scenarios/'+this.property);
    const snapshot = await get(scenarioref);
    if (snapshot.exists()) {
      this.scenario = snapshot.val();
    }
    // loop through all properties of scenario.players and convert timestamp to now timestamp
    for (let key in this.scenario.players) {
      this.scenario.players[key].datetime = this.convertTimestamp(this.scenario.players[key].timestamp)
    }

    this.worldsRef = ref(this.database, 'worlds');
    const snapshot2 = await get(this.worldsRef);
    if (snapshot2.exists()) {
      this.worlds = snapshot2.val();
      this.worldskeys = this.getKeys(this.worlds)
    }

    this.loader.hide()
  }

  async updateScenario(){
    // only update the selected scenario
    const scenRef = ref(this.database, 'scenarios/'+this.scenario.property);
    this.scenario.world = this.worldskeys[this.worldkey].name
    const fbSceneario =this.removeKeyAndPropertyFB(this.scenario)
    await set(scenRef, fbSceneario);
  }
  
  async renameScenario(){
    // add a new property with the new name
    const newname = this.newScenarioName
    const scenRef = ref(this.database, 'scenarios/'+this.newScenarioName);
    const fbSceneario =this.removeKeyAndPropertyFB(this.scenario)
    await set(scenRef, fbSceneario);
    await this.removeOneProperty('scenarios',this.scenario.property)
    this.getData()
  }

  async deletePlayer(playername: any) {
    delete this.scenario.players[playername]
    await set(ref(this.database, 'scenarios/' + this.property), this.scenario);
    await this.getData()
  }

  async removeOneProperty(path: string, property: string){
    let eventsref = ref(this.database, path);
    let events = await get(eventsref);
    let eventsdt = events.val()
    delete eventsdt[property]
    await set(ref(this.database, path), eventsdt);
  }
  openModalLessonplanStep(lpStep: any){
    if (lpStep == null){
      if (this.scenario.lessonplan == null){
        this.scenario.lessonplan = []
      }
      this.lessonplanStep = {name: '', description: '', seqNo: 10}
      this.scenario.lessonplan.push(this.lessonplanStep)
    }else{
      this.lessonplanStep = lpStep
    }
    this.showModalLessonplanStep = true
  }
  async updateLessonplanStep(){
    await set(ref(this.database, 'scenarios/' + this.property), this.scenario);
    this.showModalLessonplanStep = false
  }
}
